import React, { useState, useEffect } from 'react';
import { getReviews, fetchReviewsAsync } from '../../services/storage';

const Home = () => {
    const [reviews, setReviews] = useState(getReviews());

    useEffect(() => {
        const loadReviews = async () => {
            const data = await fetchReviewsAsync();
            setReviews(data);
        };
        loadReviews();

        const handleUpdate = () => {
            setReviews(getReviews());
        };

        window.addEventListener('cafe9_reviews_updated', handleUpdate);
        return () => window.removeEventListener('cafe9_reviews_updated', handleUpdate);
    }, []);

    // Calculate real-time average star rating
    const totalReviews = reviews.length;
    const avgScore = totalReviews > 0
        ? (reviews.reduce((sum, item) => sum + Number(item.stars), 0) / totalReviews).toFixed(1)
        : '5.0';

    return (
        <section className="hero section-full" id="home">
            <div className="hero-container">
                <div className="hero-badge">
                    <i className="fas fa-certificate"></i>
                    <span>Di Sản Cà Phê Phin Phước Hải Hơn 40 Năm</span>
                </div>

                <h1 className="hero-title">
                    Hương Vị Cà Phê <span>Nguyên Bản</span><br />
                </h1>

                <p className="hero-description">
                    Từ năm 1983, Café 9 luôn gìn giữ trọn vẹn văn hoá cà phê phin rang xay thủ công.
                    Nơi bạn tìm thấy sự bình yên, thong thả ngắm nhìn từng giọt cà phê rơi để bắt đầu một ngày mới đầy năng lượng.
                </p>

                <div className="hero-cta-group">
                    <a href="#menu" className="btn btn-primary">
                        <i className="fas fa-mug-hot"></i>
                        <span>Xem Thực Đơn</span>
                    </a>
                    <a href="#contact" className="btn btn-secondary">
                        <i className="fas fa-map-marked-alt"></i>
                        <span>Chỉ Đường & Vị Trí</span>
                    </a>
                </div>

                <div className="hero-stats-grid">
                    <div className="hero-stat-card">
                        <div className="stat-icon">
                            <i className="fas fa-hourglass-half"></i>
                        </div>
                        <div className="stat-number">40+ Năm</div>
                        <div className="stat-label">Di sản từ năm 1983</div>
                    </div>

                    <div className="hero-stat-card">
                        <div className="stat-icon">
                            <i className="fas fa-seedling"></i>
                        </div>
                        <div className="stat-number">100%</div>
                        <div className="stat-label">Cà phê nguyên chất</div>
                    </div>

                    <div className="hero-stat-card">
                        <div className="stat-icon">
                            <i className="fas fa-sun"></i>
                        </div>
                        <div className="stat-number">04:30</div>
                        <div className="stat-label">Đón bình minh làng chài</div>
                    </div>

                    <div className="hero-stat-card">
                        <div className="stat-icon">
                            <i className="fas fa-star"></i>
                        </div>
                        <div className="stat-number">{avgScore} ★</div>
                        <div className="stat-label">
                            {totalReviews > 0 ? `${totalReviews} đánh giá khách hàng` : 'Sự hài lòng của khách hàng'}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;